import React, { useState, useEffect } from "react";
import { Users, Plus, Edit, Copy, PlusCircle, Link } from "feather-icons-react/build/IconComponents";
import SessionControl from "../../components/SessionControl/sessioncontrol";
import CheckRestauSelected from "../../components/SessionControl/checkrestauselected";
import { all_routes } from "../../../Router/all_routes";
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import '../../../feature-module/pages/menus/MyButton.css';

const AccessCuisine = () => {
  const route = all_routes;
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [cuisiniers, setCuisiniers] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCuisinier, setEditingCuisinier] = useState(null);
  const [newCuisinier, setNewCuisinier] = useState({
    nom_cuisinier: "",
    statut: 1
  });
  const [editForm, setEditForm] = useState({
    code: "",
    nom_cuisinier: "",
    statut: 1
  });

  // Récupérer la liste des cuisiniers
  const fetchCuisiniers = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.access_token;
      const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
      
      const response = await axios.get(`${base_api_url}api/cuisine/restaurant/${ideresto}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 || response.status === 201) {
        setCuisiniers(response.data.code || []);
        
        if (response.data.code?.length === 0) {
          MySwal.fire({
            icon: "info",
            // title: "Aucun cuisinier",
            text: "Aucun cuisinier trouvé pour ce restaurant. Ajoutez votre premier cuisinier.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error fetching cuisiniers:", error);
      
//       let errorTitle = "Erreur de chargement";
      let errorMessage = "Impossible de charger la liste des cuisiniers.";
      
      if (error.response?.status === 404) {
        errorMessage = "Aucun cuisinier trouvé pour ce restaurant.";
        setCuisiniers([]);
      } else if (error.response?.status === 401) {
//         errorTitle = "Session expirée";
        errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
      }
      
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      
      setCuisiniers([]);
    } finally {
      setLoading(false);
    }
  };

  // Ajouter un nouveau cuisinier
  const handleAddCuisinier = async (e) => {
    e.preventDefault();
    
    if (!newCuisinier.nom_cuisinier.trim()) {
      MySwal.fire({
        icon: "error",
        // title: "Nom requis",
        text: "Veuillez saisir le nom du cuisinier.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      return;
    }

    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.access_token;
      const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
      
      const payload = {
        id_restaurant: parseInt(ideresto),
        nom_cuisinier: newCuisinier.nom_cuisinier.trim(),
        statut: newCuisinier.statut
      };

      const response = await axios.post(`${base_api_url}api/cuisine`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 || response.status === 201) {
        MySwal.fire({
          icon: "success",
          // title: "Cuisinier ajouté !",
          text: response.data.message || "Le cuisinier a été ajouté avec succès.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        // Réinitialiser le formulaire et fermer le modal
        setNewCuisinier({ nom_cuisinier: "", statut: 1 });
        setShowAddModal(false);
        
        // Recharger la liste
        await fetchCuisiniers();
      }
    } catch (error) {
      console.error("Error adding cuisinier:", error);
      
//       let errorTitle = "Erreur d'ajout";
      let errorMessage = "Impossible d'ajouter le cuisinier.";
      
      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = error.response.data?.message || "Données invalides.";
            break;
          case 401:
//             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
            break;
          case 409:
            errorMessage = "Un cuisinier avec ce nom existe déjà.";
            break;
          default:
            errorMessage = error.response.data?.message || errorMessage;
        }
      }
      
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  // Modifier un cuisinier
  const handleEditCuisinier = async (e) => {
    e.preventDefault();
    
    if (!editForm.nom_cuisinier.trim()) {
      MySwal.fire({
        icon: "error",
        // title: "Nom requis",
        text: "Veuillez saisir le nom du cuisinier.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      return;
    }

    if (!editForm.code.trim()) {
      MySwal.fire({
        icon: "error",
        // title: "Code requis",
        text: "Veuillez saisir le code du cuisinier.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
      return;
    }

    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.access_token;
      
      const payload = {
        code: editForm.code.trim(),
        nom_cuisinier: editForm.nom_cuisinier.trim(),
        statut: editForm.statut
      };

      const response = await axios.put(`${base_api_url}api/cuisine/${editingCuisinier.id_code}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 || response.status === 201) {
        MySwal.fire({
          icon: "success",
          // title: "Cuisinier modifié !",
          text: response.data.message || "Le cuisinier a été modifié avec succès.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        // Réinitialiser les formulaires et fermer le modal
        setEditingCuisinier(null);
        setEditForm({ code: "", nom_cuisinier: "", statut: 1 });
        setShowEditModal(false);
        
        // Recharger la liste
        await fetchCuisiniers();
      }
    } catch (error) {
      console.error("Error editing cuisinier:", error);
      
//       let errorTitle = "Erreur de modification";
      let errorMessage = "Impossible de modifier le cuisinier.";
      
      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = error.response.data?.message || "Données invalides.";
            break;
          case 401:
//             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
            break;
          case 404:
            errorMessage = "Cuisinier non trouvé.";
            break;
          case 409:
            errorMessage = "Ce code ou nom de cuisinier existe déjà.";
            break;
          default:
            errorMessage = error.response.data?.message || errorMessage;
        }
      }
      
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  // Ouvrir le modal d'édition
  const openEditModal = (cuisinier) => {
    setEditingCuisinier(cuisinier);
    setEditForm({
      code: cuisinier.code,
      nom_cuisinier: cuisinier.nom_cuisinier,
      statut: cuisinier.statut ? 1 : 0
    });
    setShowEditModal(true);
  };

  // Fermer les modals
  const closeAddModal = () => {
    setShowAddModal(false);
    setNewCuisinier({ nom_cuisinier: "", statut: 1 });
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingCuisinier(null);
    setEditForm({ code: "", nom_cuisinier: "", statut: 1 });
  };

  // Copier le code dans le presse-papiers
  const copyToClipboard = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      MySwal.fire({
        icon: "success",
        // title: "Code copié !",
        text: "Le code a été copié dans le presse-papiers.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    } catch (err) {
      console.error("Erreur lors de la copie:", err);
      MySwal.fire({
        icon: "error",
        // title: "Erreur",
        text: "Impossible de copier le code.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    }
  };

  // Copier le lien de la cuisine dans le presse-papiers
  const copyKitchenLinkToClipboard = async () => {
    try {
      const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
      const currentHost = window.location.origin;
      const kitchenLink = `${currentHost}/cuisine?id_restaurant=${ideresto}`;

      await navigator.clipboard.writeText(kitchenLink);
      MySwal.fire({
        icon: "success",
        // title: "Lien copié !",
        text: "Le lien de la cuisine a été copié dans le presse-papiers.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    } catch (err) {
      console.error("Erreur lors de la copie:", err);
      MySwal.fire({
        icon: "error",
        // title: "Erreur",
        text: "Impossible de copier le lien de la cuisine.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    }
  };

  useEffect(() => {
    fetchCuisiniers();
  }, []);

  return (
    <div className="page-wrapper">
      <SessionControl
        storageKey="user"
        propsup="email"
        redirectTo={route.signin}
      />
      <CheckRestauSelected
        storageKey="user"
        redirectTo={route.Restaurants}
      />
      
      <div className="content">
        <div className="page-btn d-flex justify-content-between align-items-center">
          <div>
            <h2><Users className="me-2" />Accès préparateur</h2>
            <h6>Gestion des codes d&apos;accès préparateur</h6>
          </div>
          <div className="d-flex gap-2">
            <button 
              className="btn btn-outline-primary"
              onClick={copyKitchenLinkToClipboard}
              disabled={loading}
              title="Copier le lien de la cuisine"
            >
              <Link className="me-2 iconsize" size={16} />
              <span className="d-none d-md-inline">Copier lien cuisine</span>
              <span className="d-md-none">Lien</span>
            </button>
            <button 
              className="btn btn-added"
              onClick={() => setShowAddModal(true)}
              disabled={loading}
            >
              <PlusCircle className="me-2 iconsize" size={16} />
              <span className="d-none d-md-inline">Ajouter un cuisinier</span>
              <span className="d-md-none">Ajouter</span>
            </button>
          </div>
          
        </div>

        {/* Liste des cuisiniers */}
        <div className="card table-list-card mt-4">
          <div className="card-header">
            <h5 className="mb-0 d-flex justify-content-between align-items-center">
              Liste des cuisiniers
              <span className="badge bg-primary">{cuisiniers.length}</span>
            </h5>
          </div>
          <div className="card-body">
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Chargement...</span>
                </div>
              </div>
            ) : cuisiniers.length === 0 ? (
              <div className="text-center py-4 text-muted">
                <Users size={48} className="mb-3" />
                <h6>Aucun cuisinier trouvé</h6>
                <p>Commencez par ajouter votre premier cuisinier.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Nom du cuisinier</th>
                      <th>Code d&apos;accès</th>
                      <th>Statut</th>
                      <th>Date de création</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cuisiniers.map((cuisinier, index) => (
                      <tr key={cuisinier.id_code}>
                        <td>{index + 1}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-2" 
                                 style={{ width: '32px', height: '32px', fontSize: '14px', color: 'white' }}>
                              {cuisinier.nom_cuisinier.charAt(0).toUpperCase()}
                            </div>
                            <strong>{cuisinier.nom_cuisinier}</strong>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <code className="bg-light px-2 py-1 rounded me-2" style={{color: '#000'}}>
                              {cuisinier.code}
                            </code>
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => copyToClipboard(cuisinier.code)}
                              title="Copier le code"
                              style={{
                                borderRadius: '6px',
                                padding: '6px 10px',
                                border: '1px solid #6c757d',
                                backgroundColor: 'transparent',
                                color: '#6c757d',
                                transition: 'all 0.2s ease'
                              }}
                            >
                              <Copy size={14} />
                            </button>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${cuisinier.statut ? 'bg-success' : 'bg-danger'}`}>
                            {cuisinier.statut ? 'Actif' : 'Inactif'}
                          </span>
                        </td>
                        <td>
                          {new Date(cuisinier.date_creation).toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </td>
                        <td>
                          <button 
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => openEditModal(cuisinier)}
                            title="Modifier le cuisinier"
                            disabled={loading}
                            style={{
                              borderRadius: '6px',
                              padding: '6px 10px',
                              border: '1px solid #007bff',
                              backgroundColor: 'transparent',
                              color: '#007bff',
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <Edit size={14} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Modal d'ajout */}
        {showAddModal && (
          <div 
            className="modal fade show" 
            style={{ display: 'block' }} 
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div 
                className="modal-content content gradient-modal" 
                style={{ 
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                  zIndex: 1055,
                  width: "100%",
                  position: "fixed",
                  bottom: "0",
                  left: "0",
                  margin: "0",
                  padding: "20px"
                }}
              >
                <form onSubmit={handleAddCuisinier}>
                  <div className="modal-header border-0">
                    <div className="page-title">
                      <h4>
                        <Plus className="me-2" size={20} />
                        Ajouter un nouveau cuisinier
                      </h4>
                    </div>
                    {/* <button
                      type="button"
                      className="btn-close"
                      onClick={closeAddModal}
                      disabled={loading}
                    >
                      <span aria-hidden="true">×</span>
                    </button> */}
                  </div>
                  
                  <div 
                    className="modal-body border-0"
                    style={{
                      maxHeight: "60vh", 
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <div className="row">
                      <div className="col-lg-8 col-sm-8 col-12">
                        <div className="input-blocks">
                          <label className="form-label">Nom du cuisinier *</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Entrez le nom du cuisinier"
                            value={newCuisinier.nom_cuisinier}
                            onChange={(e) => setNewCuisinier({
                              ...newCuisinier,
                              nom_cuisinier: e.target.value
                            })}
                            required
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-4 col-12">
                        <div className="input-blocks">
                          <label className="form-label">Statut</label>
                          <select
                            className="form-control"
                            value={newCuisinier.statut}
                            onChange={(e) => setNewCuisinier({
                              ...newCuisinier,
                              statut: parseInt(e.target.value)
                            })}
                            disabled={loading}
                          >
                            <option value={1}>Actif</option>
                            <option value={0}>Inactif</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="modal-footer-btn custom-modal-body">
                    <button 
                      type="button"
                      className="btn btn-cancel"
                      style={{ float: "left" }}
                      onClick={closeAddModal}
                      disabled={loading}
                    >
                      Annuler
                    </button>
                    <button 
                      type="submit" 
                      className="btn btn-primary"
                      disabled={loading}
                      style={{ marginTop: "-1px"}}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Enregistrement...
                        </>
                      ) : (
                        <>
                          <Plus className="me-2" size={16} />
                          Enregistrer
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Modal de modification */}
        {showEditModal && (
          <div 
            className="modal fade show" 
            style={{ display: 'block' }} 
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div 
                className="modal-content content gradient-modal" 
                style={{ 
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                  zIndex: 1055,
                  width: "100%",
                  position: "fixed",
                  bottom: "0",
                  left: "0",
                  margin: "0",
                  padding: "20px"
                }}
              >
                <form onSubmit={handleEditCuisinier}>
                  <div className="modal-header border-0">
                    <div className="page-title">
                      <h4>
                        <Edit className="me-2" size={20} />
                        Modifier le cuisinier: {editingCuisinier?.nom_cuisinier}
                      </h4>
                    </div>
                    {/* <button
                      type="button"
                      className="btn-close"
                      onClick={closeEditModal}
                      disabled={loading}
                    >
                      <span aria-hidden="true">×</span>
                    </button> */}
                  </div>
                  
                  <div 
                    className="modal-body border-0"
                    style={{
                      maxHeight: "60vh", 
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <div className="row">
                      <div className="col-lg-4 col-sm-4 col-12">
                        <div className="input-blocks">
                          <label className="form-label">Code d&apos;accès *</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Entrez le nouveau code"
                            value={editForm.code}
                            onChange={(e) => setEditForm({
                              ...editForm,
                              code: e.target.value
                            })}
                            required
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-4 col-12">
                        <div className="input-blocks">
                          <label className="form-label">Nom du cuisinier *</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Entrez le nom du cuisinier"
                            value={editForm.nom_cuisinier}
                            onChange={(e) => setEditForm({
                              ...editForm,
                              nom_cuisinier: e.target.value
                            })}
                            required
                            disabled={loading}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-4 col-12">
                        <div className="input-blocks">
                          <label className="form-label">Statut</label>
                          <select
                            className="form-control"
                            value={editForm.statut}
                            onChange={(e) => setEditForm({
                              ...editForm,
                              statut: parseInt(e.target.value)
                            })}
                            disabled={loading}
                          >
                            <option value={1}>Actif</option>
                            <option value={0}>Inactif</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="modal-footer-btn custom-modal-body">
                    <button 
                      type="button"
                      className="btn btn-cancel"
                      style={{ float: "left" }}
                      onClick={closeEditModal}
                      disabled={loading}
                    >
                      Annuler
                    </button>
                    <button 
                      type="submit" 
                      className="btn btn-primary"
                      disabled={loading}
                      style={{marginTop: '-1px'}}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Mise à jour...
                        </>
                      ) : (
                        <>
                          <Edit className="me-2" size={16} />
                          Mettre à jour
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Modal backdrop */}
        {(showAddModal || showEditModal) && (
          <div 
            className="modal-backdrop fade show"
            style={{ zIndex: 1050 }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default AccessCuisine;